export default function Button({ bgcolor = "bg-slate-800", onClick = null, children, type = "button", className = "" }) {
    return (
        <button onClick={onClick} type={type} className={`${bgcolor} ${className} text-slate-50 py-1 px-3 rounded-md shadow-md hover:scale-105 hover:brightness-110 active:scale-95 active:brightness-90`}>
            {children}
        </button>
    )
}